// caution-helpers.js — D3 (GO Dimitri 2026-07-13) — helper PUR client.
//
// hasCautionAmount n'est plus une copie : il APPELLE la règle unique
// resolveCautionFromLog (src/lib/caution-amount.js, CommonJS pur, la même que
// le serveur lit par le relais lib/caution-amount.js). Décision Dimitri 07/10 :
// caution à 0 = pas de caution, champ vide = celle du logement parent. Il
// pilote le badge ⚠️ « Montant caution à définir » de la carte Tarification
// (InfoFbzTab) — test de parité dans caution-helpers.test.js.
//
// AUCUN import supabase ici (module pur, testable sans env).

import { resolveCautionFromLog } from './caution-amount'

/**
 * true ⇔ le serveur résout un montant de caution (Number fini > 0 : self
 * d'abord, parentLog si le champ du logement est vide).
 * false ⇔ les devis et dépôts de demande publics répondent
 * `caution_non_definie` (« Réservation bientôt disponible » côté site
 * direct).
 *
 * @param {object|null} log — logement (ou chambre) du cfg, peut porter parentLog
 * @returns {boolean}
 */
export function hasCautionAmount(log) {
  return resolveCautionFromLog(log) != null;
}
